export default {
  init() {
    this.events();
  },

  events() {
    let postTypeThrottle = null;
    $('.filter [name=post_type], .filter [name=section]').on('change', () => {
      clearTimeout(postTypeThrottle);
      postTypeThrottle = setTimeout(() => this.handleFilter(), 1500);
    });

    $('.pager__link--page').on('click', (e) => {
      e.preventDefault();

      const link = $(e.currentTarget);

      const page = link.text();

      this.handleFilter(page);
    });

    $('.pager__link--nav').on('click', (e) => {
      e.preventDefault();

      const link = $(e.currentTarget);

      let page = +$('.search-container').data('page');
      const currPage = page;

      if (link.hasClass('pager__link--prev')) {
        page--;
      }
      if (link.hasClass('pager__link--next')) {
        page++;
      }

      if (page != currPage) {
        this.handleFilter(page);
      }
    });
  },

  /**
   * Handles filters
   */
  handleFilter(page = 1) {
    const params = new URLSearchParams();

    // Search.
    const search = $('.search-form__input');
    if (search.val()) {
      params.append('s', search.val());
    }

    // Page.
    params.append('page', page);

    // Get post types
    let postTypes = [];
    $('.filter [name="post_type"]').each((_i, item) => {
      const input = $(item);

      if (input.prop('checked')) {
        postTypes.push(input.val());
      }
    });
    // Add to params
    if (postTypes.length) {
      params.append('post_type', postTypes.join(','));
    }

    // Get post types
    let sections = [];
    $('.filter [name="section"]').each((_i, item) => {
      const input = $(item);

      if (input.prop('checked')) {
        sections.push(input.val());
      }
    });
    // Add to params
    if (sections.length) {
      params.append('section', sections.join(','));
    }

    // Reload to url if has post_types
    location = location.origin + '?' + params.toString();
  },
};
